import { Card as _Card } from './card';
import { CardContent } from './card.content';
import { CardFooter } from './card.footer';
import { CardHeader } from './card.header';
import { CardStatusIcon } from './card.status-icon';

const Card = Object.assign(_Card, {
  Header: CardHeader,
  Content: CardContent,
  Footer: CardFooter,
  StatusIcon: CardStatusIcon,
});

export type { CardStatus, CardProps } from './card';
export { Card };
